<!--
  工单详情回复记录
-->
<template>
  <div class="my-table">
    <el-table :data="list">
      <el-table-column
        label="回复时间"
        prop="replayTime"
        show-overflow-tooltip
        width="200px"
      ></el-table-column>
      <el-table-column
        label="回复人"
        prop="replayName"
        show-overflow-tooltip
        width="200px"
      ></el-table-column>
      <el-table-column label="回复内容" prop="text">
        <template slot-scope="scope">
          <div class="flex">
            <div class="table-text">{{ scope.row.replayContent }}</div>
            <div class="flex" style="margin-left: 10px">
              <el-popover placement="bottom" title="" trigger="hover" v-if="scope.row.replayFiles.length > 0">
                <div>
                  <div
                    class="popover-file"
                    v-for="(item, index) in scope.row.replayFiles"
                    :key="index"
                    @click="viewFile(item)"
                  >
                    <span v-if="item.fileType == '0'"
                      >图片：{{ item.fileUrl | getFileName }}</span
                    >
                    <span v-else-if="item.fileType == '1'"
                      >视频：{{ item.fileUrl | getFileName }}</span
                    >
                    <span v-else>文档：{{ item.fileUrl | getFileName }}</span>
                  </div>
                </div>
                <div class="popover-title" slot="reference">查看附件</div>
              </el-popover>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 图片查看器 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="viewerUrl"
    />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    ElImageViewer
  },
  data() {
    return {
      list: [],

      showViewer: false, // 显示查看器
      viewerUrl: [] // 查看器图片数组
    }
  },
  computed: {},
  filters: {
    // 获取文件url中文件名称
    getFileName(data) {
      const nameArr = data.split('/')
      return nameArr.pop()
    }
  },
  watch: {},
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.$api.order.sheetReplayRecordList(this.id).then(({ data }) => {
        if (data.code == 200) {
          this.list = data.data
        }
      })
    },
    // 查看文件
    viewFile(item) {
      const url = item.fileUrl
      if (item.fileType == '0') {
        this.viewerUrl = [url]
        this.showViewer = true
      } else {
        window.open(url)
      }
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false
    }
  }
}
</script>
<style lang="scss" scoped>
.my-table {
  margin-top: 35px;
  /deep/ .el-table__row > td > .cell {
    background-color: transparent;
    height: auto;
    line-height: 26px;
  }
  /deep/ .el-table__row > td {
    padding: 10px;
    background-color: rgba(241, 245, 255, 0.6);
  }
  .text-image {
    width: 57px;
    height: 57px;
    margin-right: 10px;
    border-radius: 6px;
  }
  .table-text {
    font-size: 14px;
    color: rgba(64, 66, 79, 0.7);
    line-height: 26px;
    cursor: pointer;
  }
}

.popover-title {
  width: 70px;
  color: #409eff;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}
.popover-file {
  margin-bottom: 10px;
  color: #999;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
